import type {
  RequestMessage,
  Sheet,
  WorkerMessage,
} from '@/features/database/types/tableImport.ts'
import {
  isCSVFile,
  isExcelFile,
} from '@/features/database/utils/checkFileType.ts'
import { extractExcelData } from '@/features/database/utils/extractExcelData.ts'
import { extractCSVData } from '@/features/database/utils/extractCSVData.ts'

function sendMessage(message: WorkerMessage) {
  globalThis.postMessage(message)
}

globalThis.addEventListener(
  'message',
  async (event: MessageEvent<RequestMessage>) => {
    const data = event.data
    if (data.type === 'start') {
      const { file, sheetLimit } = data
      try {
        let data: Sheet[] = []
        if (isExcelFile(file)) {
          data = await extractExcelData(file, sheetLimit)
        }
        if (isCSVFile(file)) {
          data = await extractCSVData(file)
        }
        sendMessage({
          status: 'finish',
          data,
        })
      } catch (e) {
        sendMessage({
          status: 'fail',
        })
      }
    }
  },
)
